import { render, staticRenderFns } from "./ExpandableList.vue?vue&type=template&id=5c3f33d7&scoped=true"
import script from "./ExpandableList.vue?vue&type=script&lang=js"
export * from "./ExpandableList.vue?vue&type=script&lang=js"
import style0 from "./ExpandableList.vue?vue&type=style&index=0&id=5c3f33d7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3f33d7",
  null
  
)

export default component.exports